import { useConfirmation } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { useMount } from 'react-use';
import { routingService } from 'services/routing';

import { messages } from './SignupLoginModule.messages';
import { showQbooksVerifyEmailPopupState } from './SignupLoginModule.states';

export const useQbooksVerifyEmailPopup = () => {
    const [visible, setVisible] = useAtom(showQbooksVerifyEmailPopupState);

    const { confirmation } = useConfirmation({
        confirmMessage: messages.qbooksVerifyEmail,
        confirmButtonMessage: messages.verify,
        confirmButtonColor: 'brandQBO80',
        cancelButtonColor: 'red40',
    });

    useMount(() => {
        if (visible) {
            setVisible(false);

            confirmation()
                .then(() => {
                    routingService.navigateToExternalUrlInNewTab(
                        'https://accounts.intuit.com/app/account-manager/security'
                    );
                })
                .catch(() => {});
        }
    });
};
